import React from "react";
import AutoScroll from "./AutoScroll";
import { useStore } from "@/store/StoreContext";

const PRESS_LOGOS = Array.from({ length: 9 }, (_, i) => `/assets/press/${i + 1}-media-logo.jpg`);

export default function FeaturedIn() {
  const { content } = useStore();
  return (
    <section data-testid="featured-in" className="border-y border-[#E9DFC8] py-8">
      <p className="mb-6 text-center text-[10px] font-semibold uppercase tracking-[0.4em] text-[#6B5B45]">{content?.press_label || "As Featured In"}</p>
      <AutoScroll testid="press-scroller" speed={0.6} itemWidth={180} arrows={false} pausable={false} gapClass="gap-16">
        {PRESS_LOGOS.map((src, i) => (
          <span key={src} data-testid={`press-logo-${i + 1}`} className="flex h-[60px] w-[160px] items-center justify-center">
            <img
              src={src}
              alt={`Featured in media ${i + 1}`}
              loading="lazy"
              className="h-10 max-w-[150px] object-contain opacity-70 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0"
            />
          </span>
        ))}
      </AutoScroll>
    </section>
  );
}
